import { AppVariables } from "./types";

function buildAppVariables() {
  return {
    APP_ENV: process.env.APP_ENV || "",
    AERIALYTIC_API_KEY: process.env.AERIALYTIC_API_KEY || "",
    AERIALYTIC_IFRAME_URL: process.env.AERIALYTIC_IFRAME_URL || "",
    GOOGLE_ANALYTICS: process.env.GOOGLE_ANALYTICS || null,
    NEXT_PUBLIC_RELEASE_NAME: process.env.NEXT_PUBLIC_RELEASE_NAME || "",
    SENTRY_DSN: process.env.SENTRY_DSN || null,
    V2_DOMAIN: process.env.V2_DOMAIN || "",
  };
}

class AppVariablesStore {
  private static instance: AppVariablesStore;
  private variables: AppVariables;

  private constructor() {
    this.variables = buildAppVariables();
  }

  public static getInstance() {
    if (!AppVariablesStore.instance) {
      AppVariablesStore.instance = new AppVariablesStore();
    }

    return AppVariablesStore.instance;
  }

  public getVariables() {
    return this.variables;
  }

  public setVariables(newVariables: AppVariables) {
    this.variables = newVariables;
  }
}

export const VariablesStore = AppVariablesStore.getInstance();

export const withAppVariables = (): { appVariables: AppVariables } => {
  const appVariables = buildAppVariables();
  // Update variables to the singleton when pages are loaded
  VariablesStore.setVariables(appVariables);

  return {
    appVariables,
  };
};
